import React, { useState } from "react";
import { showToast } from "../../Shared/Toaster";
import "../../../css/AddCampCenterModal.css";
import api from "../../../api/axiosConfig"; // ✅ axios instance
import CitySelect from "../../Shared/CitySelect";

interface AddCampCenterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void; // optional callback to refresh data after add
}

const AddCampCenterModal: React.FC<AddCampCenterModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const [city, setCity] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries());

    // Build payload
    const payload = {
      name: data.centerName,
      centerType: "CAMP CENTER",
      addressLine1: data.address1,
      addressLine2: data.address2,
      city: city || (data.city as string) || "",
      telephone1: data.telephone1,
      telephone2: data.telephone2, // adjust if it's actually email
      latitude: parseFloat(data.latitude as string),
      longitude: parseFloat(data.longitude as string),
    };

    try {
      const token = sessionStorage.getItem("accessToken"); // ✅ from sessionStorage
      const res = await api.center_api.post("/api/v1/centers", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Center created:", res.data);
      showToast("Camp center created successfully ✅", "success");

      if (onSuccess) onSuccess();
      onClose();
    } catch (err: any) {
      console.error("Error creating center:", err);
      showToast(err.response?.data?.message || "Error creating camp center ❌", "error");
    }
  };

  return (
    <div className="add-camp-center-modal-overlay" onClick={onClose}>
      <div className="add-camp-center-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="add-camp-center-modal-header">
          <h2>Add Camp Center</h2>
          <button
            type="button"
            className="add-camp-center-close-btn"
            onClick={onClose}
            aria-label="Close camp center modal"
          >
            ✕
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <label>Center Name</label>
          <input className="add-camp-center-input-field" name="centerName" type="text" required />

          <label>Address 1</label>
          <input className="add-camp-center-input-field" name="address1" type="text" required />

          <label>Address 2</label>
          <input className="add-camp-center-input-field" name="address2" type="text" />

          <label>City</label>
          <CitySelect value={city} onChange={setCity} placeholder="Select city" />

          <label>Telephone 1</label>
          <input className="add-camp-center-input-field" name="telephone1" type="text" />

          <label>Telephone 2</label>
          <input className="add-camp-center-input-field" name="telephone2" type="text" />

          {/* Removed mapCoordinates */}
          <label>Latitude</label>
          <input className="add-camp-center-input-field" name="latitude" type="number" step="any" required />

          <label>Longitude</label>
          <input className="add-camp-center-input-field" name="longitude" type="number" step="any" required />

          <div className="add-camp-center-modal-actions">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit">Add Camp Center</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCampCenterModal;
